import { msg } from 'gt-react';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../../../route';
import { SD_844_CONFIGURATION_ACCESS } from '..';

const Sd844SupplierTemplatePage = lazyRouteComponent(
  () => import('../Sd844SupplierTemplatePage'),
  'Sd844SupplierTemplatePage',
);

/** `$companyId` is a supplier's company id, or `default` for the org default. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/844-configuration/$companyId',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: SD_844_CONFIGURATION_ACCESS,
      },
    },
  },
  component: Sd844SupplierTemplatePage,
  loader: () => ({
    crumb: msg('844 Template', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.SHIP_AND_DEBIT] });
    await requireAnyPermission({
      context,
      permissions: SD_844_CONFIGURATION_ACCESS,
    });
  },
});
